export const ADD_COURSE = 'ADD_COURSE';
export const addCourse = (course) => { 
    return {type: ADD_COURSE, course}
}